import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=1b6be25e&"
import script from "./Slide.vue?vue&type=script&lang=ts&"
export * from "./Slide.vue?vue&type=script&lang=ts&"
import style0 from "./Slide.vue?vue&type=style&index=0&id=1b6be25e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports